export class CreateRoleResponse {
    'role';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "role",
            "baseName": "role",
            "type": "Role",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateRoleResponse.attributeTypeMap;
    }
    constructor() {
    }
}
